import React, { useState } from 'react';
import { View, StyleSheet, Dimensions, Pressable, TouchableOpacity } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import Space from '../../space/Space';
import TextInput from '../../textInput/TextInput';
import Icon from '../../icon/Icon';
import ThemeProvider from '@voltmoney/theme';
import EmptyScreen from './EmptyScreen';
import CustomerTable from './CustomerTable';
import InterestTable from './InterestTable';
import RenewalTable from './RenewalTable';
import ShortfallTable from './ShortfallTable';
import ShimmerTable from './ShimmerTable';
import { showShareLink } from '../utils';
const CustomerDetailsTable = ({ height, activeTab = 0, tabData, numberOfFilterApplied, filterObj, customerData, currentPageCustomer, totalNoOfPages, actualPageSizeCustomer, navigateToInterestFilter, navigateToCustomerFilter, navigateToRenewalFilter, navigateToShortfallFilter, navigateToCustomerDetails, navigateToCustomerJourney, navigateToShareLink, navigateToCustomerScreenDebounce, navigateToInterestScreenDebounce, navigateToRenewalScreenDebounce, navigateToShortfallScreenDebounce, navigateToCustomerScreen, navigateToInterestScreen, navigateToRenewalScreen, navigateToShortfallScreen, dataFetched = false, navigateToInterestCalculator, triggerAction, }) => {
    const screenWidth = Dimensions.get('window').width;
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [showLink, setShowLink] = useState(showShareLink());
    const [currentActiveTab, setCurrentActiveTab] = useState(activeTab);
    const [searchText, setSearchText] = useState('');
    const [isFilterSelected, setIsFilterSelected] = useState(numberOfFilterApplied > 0 ? true : false);
    const [newFilteObj, setNewFilterObj] = useState(filterObj);
    const clearTextSearchAction = () => {
        setSearchText('');
        if (searchText?.length > 0)
            handleSearch('');
    };
    const handleAction = async (index) => {
        setIsFilterSelected(false);
        setNewFilterObj({});
        if (index === 0 && currentActiveTab !== 0)
            await triggerAction({
                ...navigateToCustomerScreen,
                payload: {
                    tabClicked: true,
                    ...navigateToCustomerScreen.payload,
                }
            });
        else if (index === 1 && currentActiveTab !== 1)
            await triggerAction({
                ...navigateToInterestScreen,
                payload: {
                    ...navigateToInterestScreen.payload,
                    tabClicked: true,
                }
            });
        else if (index === 2 && currentActiveTab !== 2)
            await triggerAction({
                ...navigateToRenewalScreen,
                payload: {
                    ...navigateToRenewalScreen.payload,
                    tabClicked: true,
                }
            });
        else if (index === 3 && currentActiveTab !== 3)
            await triggerAction({
                ...navigateToShortfallScreen,
                payload: {
                    ...navigateToShortfallScreen.payload,
                    tabClicked: true,
                }
            });
        setCurrentActiveTab(index);
    };
    const handleSearch = async (text) => {
        if (text?.includes('+')) {
            if (text?.length === 1)
                return;
            else
                text = text?.substr(1, text);
        }
        if (currentActiveTab === 1) {
            await triggerAction({
                ...navigateToInterestScreenDebounce,
                payload: {
                    searchText: text,
                    isDebounce: true,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilteObj : {},
                    ...navigateToInterestScreenDebounce.payload
                }
            });
        }
        else if (currentActiveTab === 2) {
            await triggerAction({
                ...navigateToRenewalScreenDebounce,
                payload: {
                    searchText: text,
                    isDebounce: true,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilteObj : {},
                    ...navigateToRenewalScreen.payload
                }
            });
        }
        else if (currentActiveTab === 3) {
            await triggerAction({
                ...navigateToShortfallScreenDebounce,
                payload: {
                    searchText: text,
                    isDebounce: true,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilteObj : {},
                    ...navigateToShortfallScreenDebounce.payload
                }
            });
        }
        else {
            await triggerAction({
                ...navigateToCustomerScreenDebounce,
                payload: {
                    searchText: text,
                    isDebounce: true,
                    renderFilterSelected: numberOfFilterApplied > 0 ? newFilteObj : {},
                    ...navigateToCustomerScreenDebounce.payload
                }
            });
        }
    };
    const renderContent = () => (React.createElement(View, { style: { width: screenWidth - 290, paddingRight: screenWidth <= 1600 ? 10 : (screenWidth - 1590) } },
        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
            React.createElement(View, null,
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Completed applications', color: ColorTokens.Grey_Night }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Track your completed applications', color: ColorTokens.Grey_Charcoal })),
            showLink &&
                React.createElement(View, null,
                    React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Share unique link', onPress: async () => { await triggerAction(navigateToShareLink); }, isDisabled: false }))),
        React.createElement(View, { style: { flexDirection: 'row', marginTop: 24 } }, tabData?.map(({ label, count }, i) => (React.createElement(Pressable, { key: `${label}`, style: {
                paddingHorizontal: 40,
                borderBottomWidth: 1,
                borderColor: i === currentActiveTab ? colorMapping[ColorTokens.Primary_100] : colorMapping[ColorTokens.Grey_Chalk]
            }, onPress: () => { handleAction(i); } },
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', marginBottom: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: label, color: i === currentActiveTab ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginLeft: 8, paddingHorizontal: 5, paddingVertical: 1, backgroundColor: (count > 0 && i > 0) ? '#FF7B7E' : '#E4E7EC', borderRadius: 24 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3S, label: count > 0 ? count : '0', color: (count > 0 && i > 0) ? ColorTokens.White : ColorTokens.Grey_Charcoal }))))))),
        React.createElement(View, { style: { marginTop: 20, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                React.createElement(View, { style: { marginRight: 10, width: '100%' } },
                    React.createElement(TextInput, { state: InputStateToken.DEFAULT, type: InputTypeToken.SEARCH, keyboardType: KeyboardTypeToken.default, alphaNumericSpace: true, title: "Search customer", needSearchIcon: true, onChangeText: (text) => {
                            if (text !== searchText) {
                                setSearchText(text);
                                handleSearch(text);
                            }
                        }, value: searchText, placeholder: 'Search by name or phone number', clearTextAction: clearTextSearchAction })),
                React.createElement(View, { style: { width: '40%', top: 4 } },
                    React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Search', onPress: () => {
                            handleSearch(searchText);
                        }, isDisabled: searchText?.length == 0 }))),
            React.createElement(View, null,
                isFilterSelected &&
                    React.createElement(View, { style: styles.filterNumberOverlay },
                        React.createElement(Typography, { label: numberOfFilterApplied, fontSize: FontSizeTokens.XXS, lineHeight: 18, color: ColorTokens.White, fontWeight: "400" })),
                React.createElement(TouchableOpacity, { style: styles.filterButton, onPress: async () => {
                        if (currentActiveTab === 0 && navigateToCustomerFilter) {
                            await triggerAction({
                                ...navigateToCustomerFilter,
                                payload: {
                                    currentActiveTab,
                                    filterObj: newFilteObj,
                                    searchText,
                                    ...navigateToCustomerFilter.payload
                                }
                            });
                        }
                        else if (currentActiveTab === 1 && navigateToInterestFilter) {
                            await triggerAction({
                                ...navigateToInterestFilter,
                                payload: {
                                    currentActiveTab,
                                    filterObj: newFilteObj,
                                    searchText,
                                    ...navigateToInterestFilter.payload
                                }
                            });
                        }
                        else if (currentActiveTab === 2 && navigateToRenewalFilter) {
                            await triggerAction({
                                ...navigateToRenewalFilter,
                                payload: {
                                    currentActiveTab,
                                    filterObj: newFilteObj,
                                    searchText,
                                    ...navigateToRenewalFilter.payload
                                }
                            });
                        }
                        else if (currentActiveTab === 3 && navigateToShortfallFilter) {
                            await triggerAction({
                                ...navigateToShortfallFilter,
                                payload: {
                                    currentActiveTab,
                                    filterObj: newFilteObj,
                                    searchText,
                                    ...navigateToShortfallFilter.payload
                                }
                            });
                        }
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "Filter", color: ColorTokens.Primary_100 }),
                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                    React.createElement(Icon, { name: IconTokens.Filter, size: IconSizeTokens.XL })))),
        dataFetched === true && (customerData?.length === 0 || !customerData) &&
            React.createElement(EmptyScreen, { activeTab: currentActiveTab, navigateToInterestCalculator: navigateToInterestCalculator, triggerAction: triggerAction, isFilterSelected: isFilterSelected, navigateToCustomerScreen: navigateToCustomerScreen, navigateToInterestScreen: navigateToInterestScreen, navigateToRenewalScreen: navigateToRenewalScreen, navigateToShortfallScreen: navigateToShortfallScreen, searchText: searchText, setIsFilterSelected: setIsFilterSelected, setNewFilterObj: setNewFilterObj }),
        dataFetched === false && React.createElement(ShimmerTable, null),
        currentActiveTab === 0 && dataFetched === true && customerData?.length > 0 && React.createElement(CustomerTable, { tabData: tabData, customerData: customerData, navigateToCustomerDetails: navigateToCustomerDetails, navigateToCustomerJourney: navigateToCustomerJourney, navigateToShareLink: navigateToShareLink, navigateToCustomerScreen: navigateToCustomerScreen, currentPageCustomer: currentPageCustomer, totalNoOfPages: totalNoOfPages, actualPageSizeCustomer: actualPageSizeCustomer, activeTab: currentActiveTab, filterObj: filterObj, searchText: searchText, filterSelected: isFilterSelected, triggerAction: triggerAction, numberOfFilterApplied: numberOfFilterApplied }),
        currentActiveTab === 1 && dataFetched === true && customerData?.length > 0 && React.createElement(InterestTable, { tabData: tabData, customerData: customerData, activeTab: currentActiveTab, navigateToCustomerDetails: navigateToCustomerDetails, navigateToCustomerJourney: navigateToCustomerJourney, navigateToShareLink: navigateToShareLink, currentPageCustomer: currentPageCustomer, totalNoOfPages: totalNoOfPages, actualPageSizeCustomer: actualPageSizeCustomer, navigateToInterestScreen: navigateToInterestScreen, filterObj: filterObj, searchText: searchText, filterSelected: isFilterSelected, triggerAction: triggerAction, numberOfFilterApplied: numberOfFilterApplied }),
        currentActiveTab === 2 && dataFetched === true && customerData?.length > 0 && React.createElement(RenewalTable, { tabData: tabData, customerData: customerData, activeTab: currentActiveTab, currentPageCustomer: currentPageCustomer, totalNoOfPages: totalNoOfPages, actualPageSizeCustomer: actualPageSizeCustomer, navigateToRenewalScreen: navigateToRenewalScreen, navigateToCustomerDetails: navigateToCustomerDetails, navigateToCustomerJourney: navigateToCustomerJourney, navigateToShareLink: navigateToShareLink, filterObj: filterObj, searchText: searchText, filterSelected: isFilterSelected, triggerAction: triggerAction, numberOfFilterApplied: numberOfFilterApplied }),
        currentActiveTab === 3 && dataFetched === true && customerData?.length > 0 && React.createElement(ShortfallTable, { tabData: tabData, customerData: customerData, activeTab: currentActiveTab, currentPageCustomer: currentPageCustomer, totalNoOfPages: totalNoOfPages, actualPageSizeCustomer: actualPageSizeCustomer, navigateToShortfallScreen: navigateToShortfallScreen, navigateToCustomerDetails: navigateToCustomerDetails, navigateToCustomerJourney: navigateToCustomerJourney, navigateToShareLink: navigateToShareLink, filterObj: filterObj, searchText: searchText, filterSelected: isFilterSelected, triggerAction: triggerAction, numberOfFilterApplied: numberOfFilterApplied })));
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: ColorTokens.White, bottomChildren: React.createElement(React.Fragment, null) }, renderContent()));
};
const styles = StyleSheet.create({
    table: {
        marginTop: 24,
        marginBottom: 120,
        display: 'flex',
        flex: 1,
        flexGrow: 1,
    },
    headingCell: {
        backgroundColor: '#F5F5F5',
    },
    headingText: {
        fontWeight: 'bold',
        textAlign: 'center',
    },
    filterButton: {
        flexDirection: 'row',
        borderRadius: 23,
        borderWidth: 1,
        borderColor: '#1434CB',
        paddingHorizontal: 16,
        paddingVertical: 4,
        alignItems: 'center',
    },
    cell: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: 8,
        flexWrap: 'wrap',
    },
    cellText: {
        textAlign: 'center',
        flexWrap: 'wrap',
    },
    filterNumberOverlay: {
        alignItems: 'center',
        alignSelf: 'flex-end',
        justifyContent: 'center',
        width: 20,
        height: 20,
        marginBottom: 12,
        backgroundColor: "#1434CB",
        borderRadius: 32,
        top: 0,
        right: 0,
        bottom: 12,
        marginRight: 8,
        position: 'absolute'
    }
});
export default CustomerDetailsTable;
